export default {
    install(app) {
        app.config.globalProperties.$helper = this
    },
    priceFormatter(price, toman = true) {
        try {
            let formattedPrice =
                price
                    .toFixed(0)
                    .replace(new RegExp('\\d(?=(\\d{3})+$)', 'g'), '$&,');

            if (toman) {
                return formattedPrice + " تومان "
            }

            return formattedPrice
        } catch (e) {
            return 0 + " تومان"
        }
    },

    renderCategoryType(type) {
        switch (type) {
            case 'restaurant':
                return 'رستوران'
            case 'shop':
                return 'فروشگاه'
            case 'caffe':
                return 'کافی شاپ'
            case 'service':
                return 'خدمات'
        }
    },

    validationError(errorResponse, errorArray) {
        let response = errorResponse.response.data
        errorArray.push(response.message)

        for (let key in response.errors) {
            errorArray.push(key + ': ' + response.errors[key])
        }
    },

    renderStatus(status) {
        switch (status) {
            case 'pending':
                return 'در انتظار'
            case 'seen':
                return 'دیده شده'
            case 'delivered':
                return 'تحویل شده'
            case 'rejected':
                return 'رد شده'
            case 'paid':
                return 'پرداخت شده'
            case 'canceled':
                return 'لغو شده'
        }
    },

    renderStatusClass(status) {
        switch (status) {
            case 'pending':
                return 'warning'
            case 'seen':
                return 'info'
            case 'delivered':
            case 'paid':
                return 'success'
            case 'rejected':
            case 'canceled':
                return 'danger'
        }
    },

    getTextValue(lang, textContent) {
        if (lang.code === 'fa')
            return textContent?.text
        else
            return textContent
                ?.translations
                ?.find(item => item.language_id === lang.id)
                ?.text
    }
}